/** @jsx dom */
import dom from 'magic-virtual-element';
import {utils as cmsUtils} from '@viskan/cms-components';
import Link from '../../../link';

const render = ({props}) => {
	const {customer, getTranslation, email, name, mypages, logout, styleClasses} = props;
	const {logged_in} = customer;

	if (!logged_in) {
		return <noscript/>;
	}

	return cmsUtils.createCmsComponent((
		<ul class='CMS-account-details'>
			<div class='CMS-account-details-title'>{getTranslation('account.loggedin')}</div>
			{email ? <li class={['CMS-account-details-email', styleClasses && styleClasses.Email]} data-style-attr='Email'>{customer.email_1}</li> : <noscript data-style-attr='Email'/>}
			{name ? <li class={['CMS-account-details-name', styleClasses && styleClasses.Name]} data-style-attr='Name'>{customer.cust_desc2} {customer.cust_desc1}</li> : <noscript data-style-attr='Name'/>}
			{mypages ? <li class={['CMS-account-details-mypages-wrapper', styleClasses && styleClasses.MypagesWrapper]} data-style-attr='MypagesWrapper'><Link class={['CMS-account-details-mypages', styleClasses && styleClasses.Mypages]} data-style-attr='Mypages' href='/account'>{getTranslation('account.my_pages')}</Link></li> : <noscript data-style-attr='Mypages'/>}
			{logout ? <li class={['CMS-account-details-logout-wrapper', styleClasses && styleClasses.LogoutWrapper]} data-style-attr='LogoutWrapper'><Link class={['CMS-account-details-logout', styleClasses && styleClasses.Logout]} data-style-attr='Logout' href='/logout'>{getTranslation('login.logout')}</Link></li> : <noscript data-style-attr='Logout'/>}
		</ul>
	), props);
};

export default {render};
